import { ReactNode, useCallback, useState } from "react";
import { Image } from "components/Image";
import { Box } from "@mui/material";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { FileThumbnail, ThumbnailType } from "types";
import { FileFallback } from "./FileView/FileFallback";

export type ImageViewerProps = {
    url?: string,
    thumbnails: FileThumbnail[],
    fileView: ThumbnailType;
    name?: string,
    allowZoomPanPinch?: boolean,
    cursor?: string,
    onClick?: () => void,
    onSuccess?: () => void,
    onError?: () => void,
}

export function ImageViewer({ url, thumbnails, fileView, name, allowZoomPanPinch, cursor, onClick, onSuccess, onError }: ImageViewerProps) {

    const thumbnail = thumbnails.find(x => x.type === fileView);

    const fallbackComponent = fileView === "tile"
        ? <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <FileFallback name={name} />
        </Box>
        : <Image
            url={url}
            name={name}
            onClick={onClick}
            onSuccess={onSuccess}
            cursor={cursor}
        />

    return (
        <ZoomPanPinchImageContainer name={name} url={url} allowZoomPanPinch={allowZoomPanPinch}>
            <Image
                url={fileView === "original" ? url : thumbnail?.href}
                fallback={fallbackComponent}
                name={name}
                onClick={onClick}
                onSuccess={onSuccess}
                cursor={cursor}
            />
        </ZoomPanPinchImageContainer>
    );
}

function ZoomPanPinchImageContainer({ url, name, allowZoomPanPinch, children }: { url: string, name: string, allowZoomPanPinch: boolean, children: ReactNode }) {

    const [loading, setLoading] = useState(true);

    if (!allowZoomPanPinch) return <>{children}</>;

    //preload the image, so TransformWrapper will instantiate TransformComponent with the right dimension & placement
    if (loading) {
        return <Image url={url} name={name} onSuccess={() => setLoading(false)} />
    }

    return (
        <TransformWrapper centerOnInit={true}>
            <TransformComponent wrapperStyle={{ width: "100%", height: "100%", cursor: "move" }} contentStyle={{ height: "100%" }}>
                <Box width="100%" height="100%">
                    {children}
                </Box>
            </TransformComponent>
        </TransformWrapper>
    );
}
